import { Box, Button, Typography } from '@mui/material';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import { useState } from 'react';
import { StyledContainer } from '../../dynamicform/styled';
import { CONTACT_TOPICS } from '../../util/constants.js';
import FeedbackContactForm from './FeedbackContactForm.jsx';
import { validateAuth, getApiBaseUrl } from '../../util/util.js';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { userTypeSelector } from '../../redux/selectors.js';
import { capitalizeName } from '../../util/util.js';
import { notificationSuccess, notificationError } from '../../redux/actions/app.js';

function ContactButton() {
  const [showContactForm, setShowContactForm] = useState(false);
  const dispatch = useDispatch();
  const currentUserType = useSelector(userTypeSelector);

  const handleSubmit = ({ type, description }) => {
    validateAuth((session) => {
      axios
        .post(
          `${getApiBaseUrl(currentUserType.type)}/contact_us`,
          {
            type,
            description,
            email: currentUserType.user.email,
            name: capitalizeName(currentUserType.user.name),
          },
          {
            headers: { Authorization: session.getIdToken().getJwtToken() },
            timeout: 15 * 1000,
          }
        )
        .then(() => {
          dispatch(notificationSuccess('Message sent successfully'));
          setTimeout(() => setShowContactForm(false), 1000);
        })
        .catch((error) => {
          dispatch(notificationError(error));
        });
    });
  };

  return (
    <>
      {/* Dim the background when the contact form is open */}
      {showContactForm && (
        <Box
          onClick={() => setShowContactForm(false)}
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 1202,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            transition: 'opacity .2s ease-in-out',
          }}
        />
      )}

      <Box
        sx={{
          position: 'fixed',
          left: 74,
          bottom: 16,
          zIndex: 1210,
        }}
      >
        <Button
          onClick={() => setShowContactForm((prev) => !prev)}
          variant="contained"
          color="primary"
          aria-label="Open contact form"
          sx={{
            width: 40,
            minWidth: 40,
            height: 40,
            borderRadius: '999px',
            px: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            transition: 'width 220ms ease, padding 220ms ease, box-shadow 220ms ease',
            '& .contact-label': {
              opacity: 0,
              maxWidth: 0,
              transition: 'opacity 150ms ease, max-width 220ms ease',
              fontWeight: 600,
              letterSpacing: '0.01em',
            },
            '&:hover': {
              width: 152,
              justifyContent: 'center',
              gap: 1,
              px: 0,
              boxShadow: 6,
            },
            '&:hover .contact-label': {
              opacity: 1,
              maxWidth: 110,
            },
          }}
        >
          <MailOutlineOutlinedIcon fontSize="small" />
          <Typography component="span" variant="button" className="contact-label">
            Contact Us
          </Typography>
        </Button>
      </Box>

      {showContactForm && (
        <StyledContainer
          size="md"
          className="col gap-lg"
          style={{
            position: 'fixed',
            right: 16,
            zIndex: 1210,
            bottom: 140,
            width: 360,
            padding: 16,
            borderRadius: 8,
            boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.1)',
          }}
        >
          <FeedbackContactForm
            title="Contact Us"
            selectLabel="Topic"
            selectOptions={CONTACT_TOPICS}
            descriptionLabel="Description"
            maxDescLength={2000}
            submitLabel="Send"
            onSubmit={handleSubmit}
            onClose={() => setShowContactForm(false)}
          />
        </StyledContainer>
      )}
    </>
  );
}

export default ContactButton;
